"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioCardStyles = exports.radioStyles = void 0;
const lit_1 = require("lit");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
exports.radioStyles = (0, lit_1.css) `
  :host {
    --radio-size: var(--size-16);
    --radio-border-radius: var(--radius-full);
    --radio-border-color: var(--border-color);
    --radio-background-color: var(--background-color);
  }

  label {
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }

  label > .indicator {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    user-select: none;
    width: var(--radio-size);
    height: var(--radio-size);
    border: var(--border);
    border-color: var(--radio-border-color);
    box-sizing: border-box;
    border-radius: var(--radio-border-radius);
    background: var(--radio-background-color);
  }

  input[type='radio']:checked + label > .indicator {
    --radio-background-color: var(--interaction-selected-foreground-color);
    --radio-border-color: var(--interaction-selected-border-color);
    animation: radiomark var(--transition-duration) ease-out;
    box-shadow: 0 0 0 calc(var(--radio-size) / 4) var(--background-color) inset;
  }

  input:focus-visible + label > .indicator {
    ${shared_styles_1.focusRingStyles};
  }

  input:disabled + label {
    ${shared_styles_1.disabledStyles};
  }

  :host([size='large']) {
    --radio-size: var(--size-24);
  }

  /* 선택하면 면 전체가 선택색으로 찼다가 안쪽 링이 자라 점으로 줄어든다. 끝 값은 선택된 규칙의 box-shadow를 그대로 쓴다. */
  @keyframes radiomark {
    from {
      box-shadow: 0 0 0 0 var(--background-color) inset;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    input[type='radio']:checked + label > .indicator {
      animation: none;
    }
  }
`;
exports.radioCardStyles = (0, lit_1.css) `
  :host {
    display: block;
    --radio-card-background-color: var(--background-color);
    --radio-card-border: var(--border);
  }

  label {
    ${surface_styles_1.surfaceBaseStyles};
    --surface-border-radius: var(--radius-large);
    --surface-background-color: var(--radio-card-background-color);
    --surface-border: var(--radio-card-border);

    flex-direction: row;
    align-items: flex-start;
    gap: var(--space-3);
  }

  /* label이 align-items: flex-start라 슬롯 콘텐츠가 늘어나도 인디케이터가 첫 줄에 정렬되고 찌그러지지 않게 한다. */
  label > .indicator {
    flex-shrink: 0;
    margin-block-start: var(--space-1);
  }

  slot {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }

  input:not(:checked):not(:disabled) + label:hover {
    --radio-card-background-color: var(--interaction-hover-background-color);
  }

  input[type='radio']:checked + label {
    --radio-card-border: var(--border-width) solid var(--interaction-selected-border-color);
    --radio-card-background-color: var(--interaction-selected-background-color);
  }

  input:focus-visible + label {
    ${shared_styles_1.focusRingStyles};
  }

  input:focus-visible + label > .indicator {
    outline: none;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaW8uc3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmFkaW8uc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF5QjtBQUV6QiwrRUFBOEU7QUFDOUUsK0RBQTZFO0FBRWhFLFFBQUEsV0FBVyxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01BcUN4QiwrQkFBZTs7OztNQUlmLDhCQUFjOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBbUJuQixDQUFBO0FBRVksUUFBQSxlQUFlLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7O01BUTVCLGtDQUFpQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUFnQ2pCLCtCQUFlOzs7Ozs7Q0FNcEIsQ0FBQSJ9